import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const EditActivityForm: React.FC<{ 
    viewKey?: string, 
    linkedItem?: { [key: string]: number }
}> = ({ viewKey, linkedItem }) => {

    const apiObject = 'activity'

    // Configure the activity group fields
    const fields: FieldType[] = [
        { 
            type: 'dropdown', 
            name: 'time_type', 
            label: 'timerow.general.type_label', 
            apiRequest: [{
                endpoint: 'get_non_productive_timetype_list',
                object: 'non_productive_timetype',
                params: { is_active: true },
                useCache: true
            }],
            disabled_selected: 'timerow.general.type_disabled_selected',
            allowNoneOption: false,
            showSearch: false,
        },
        {
            type: 'textarea',
            name: 'note',
            label: 'timerow.general.note_label',
            rows: 3,
            isNote: true,
            placeholder: 'timerow.general.note_placeholder',
        },
        // {
        //     type: 'header',
        // },
        {
            type: 'date',
            name: 'start_date',
            label: 'timerow.general.start_date_label',
            defaultValue: linkedItem?.selectedDate !== undefined ? String(linkedItem?.selectedDate) : undefined, 
            width: '40%',
            group: 'field-row',
            convertTimezone: true,
            utcDatetime: 'start_datetime'
        },
        // {
        //     type: 'date',
        //     name: 'end_date',
        //     label: 'timerow.general.end_date_label',
        //     width: '50%',
        //     group: 'field-row',
        // },
        {
            type: 'time',
            name: 'start_time',
            label: 'timerow.general.start_time_label',
            defaultValue: linkedItem?.selectedTime !== undefined ? String(linkedItem?.selectedTime) : undefined,
            width: '30%',
            group: 'field-row',
            convertTimezone: true,
            utcDatetime: 'start_datetime'
        },
        {
            type: 'time',
            name: 'end_time',
            label: 'timerow.general.end_time_label',
            width: '30%',
            group: 'field-row',
            convertTimezone: true,
            utcDatetime: 'end_datetime'
        },
        // {
        //     name: 'weekdays',
        //     label: 'timerow.general.select_weekdays_label',
        //     tooltipText: 'timerow.general.select_weekdays_tooltipText',
        //     type: 'multi-tabs',
        //     fullWidth: true,
        //     defaultValue: ["monday", "tuesday", "wednesday", "thursday", "friday"],
        //     hardcodedOptions: [
        //         { value: "monday", name: "Ma" },
        //         { value: "tuesday", name: "Di" },
        //         { value: "wednesday", name: "Wo" },
        //         { value: "thursday", name: "Do" },
        //         { value: "friday", name: "Vr" },
        //         { value: "saturday", name: "Za" },
        //         { value: "sunday", name: "Zo" },
        //     ],
        // },
        // {
        //     type: 'header',
        // },
        { 
            type: 'dropdown', 
            name: 'assignee', 
            label: 'timerow.general.assignees_label',
            apiRequest: [{
                endpoint: `get_user_list`,
                object: 'user',
                params: { is_active: true }
            }],
            disabled_selected: 'timerow.general.assignees_disabled_selected',
            allowNoneOption: false,
            optionFormat: 'full_name',
            selectionFormat: 'full_name',
        },        
        {
            name: 'custom_color',
            label: 'timerow.general.color_label',
            type: 'tabs',
            showIconOnly: true,
            customClass: "label",
            options: [
                { value: "soft-dark-blue", name: "soft-dark-blue" },
                { value: "soft-blue", name: "soft-blue" },
                { value: "soft-dark-green", name: "soft-dark-green" },
                { value: "soft-green", name: "soft-green" },
                { value: "soft-yellow", name: "soft-yellow" },
                { value: "soft-orange", name: "soft-orange" },
                { value: "soft-red", name: "soft-red" },
                { value: "soft-gray", name: "soft-gray" },
                { value: "soft-dark-gray", name: "soft-dark-gray" },
                { value: "soft-purple", name: "soft-purple" },
            ],
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields} 
            linkedItem={linkedItem}    
            showDeleteButton={true}  
        />
    );
};

export default EditActivityForm;